export default __webpack_public_path__ + "static/media/photo_gallery_border.16433b73.png";